module.exports = __webpack_public_path__ + "img/preview.20730908.png";